import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

import { Event, PauseableEmitter } from '../../../base/common/event.js';
import { DisposableStore } from '../../../base/common/lifecycle.js';
import { CommandsRegistry } from '../../commands/common/commands.js';
import { IConfigurationService } from '../../configuration/common/configuration.js';
import { IContextKeyService, SET_CONTEXT_COMMAND_ID } from '../common/contextkey.js';
import { KeybindingResolver } from '../../keybinding/common/keybindingResolver.js';
var KEYBINDING_CONTEXT_ATTR = 'data-keybinding-context';
export var Context = /*#__PURE__*/function () {
  function Context(id, parent) {
    _classCallCheck(this, Context);

    this._id = id;
    this._parent = parent;
    this._value = Object.create(null);
    this._value['_contextId'] = id;
  }

  _createClass(Context, [{
    key: "setValue",
    value: function setValue(key, value) {
      // console.log('SET ' + key + ' = ' + value + ' ON ' + this._id);
      if (this._value[key] !== value) {
        this._value[key] = value;
        return true;
      }

      return false;
    }
  }, {
    key: "removeValue",
    value: function removeValue(key) {
      // console.log('REMOVE ' + key + ' FROM ' + this._id);
      if (key in this._value) {
        delete this._value[key];
        return true;
      }

      return false;
    }
  }, {
    key: "getValue",
    value: function getValue(key) {
      var ret = this._value[key];

      if (typeof ret === 'undefined' && this._parent) {
        return this._parent.getValue(key);
      }

      return ret;
    }
  }]);

  return Context;
}();

var NullContext = /*#__PURE__*/function (_Context) {
  _inherits(NullContext, _Context);

  var _super = _createSuper(NullContext);

  function NullContext() {
    _classCallCheck(this, NullContext);

    return _super.call(this, -1, null);
  }

  _createClass(NullContext, [{
    key: "setValue",
    value: function setValue(key, value) {
      return false;
    }
  }, {
    key: "removeValue",
    value: function removeValue(key) {
      return false;
    }
  }, {
    key: "getValue",
    value: function getValue(key) {
      return undefined;
    }
  }]);

  return NullContext;
}(Context);

NullContext.INSTANCE = new NullContext();

var ConfigAwareContextValuesContainer = /*#__PURE__*/function (_Context2) {
  _inherits(ConfigAwareContextValuesContainer, _Context2);

  var _super2 = _createSuper(ConfigAwareContextValuesContainer);

  function ConfigAwareContextValuesContainer(id, _configurationService, emitter) {
    var _this;

    _classCallCheck(this, ConfigAwareContextValuesContainer);

    _this = _super2.call(this, id, null);
    _this._configurationService = _configurationService;
    _this._values = new Map();
    _this._listener = _this._configurationService.onDidChangeConfiguration(function (event) {
      if (event.source === 6
      /* DEFAULT */
      ) {
        // new setting, reset everything
        var allKeys = Array.from(_this._values.keys());

        _this._values.clear();

        emitter.fire(new ArrayContextKeyChangeEvent(allKeys));
      } else {
        var changedKeys = [];

        var _iterator = _createForOfIteratorHelper(event.affectedKeys),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var configKey = _step.value;
            var contextKey = "config.".concat(configKey);

            if (_this._values.has(contextKey)) {
              _this._values.delete(contextKey);

              changedKeys.push(contextKey);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        emitter.fire(new ArrayContextKeyChangeEvent(changedKeys));
      }
    });
    return _this;
  }

  _createClass(ConfigAwareContextValuesContainer, [{
    key: "dispose",
    value: function dispose() {
      this._listener.dispose();
    }
  }, {
    key: "getValue",
    value: function getValue(key) {
      if (key.indexOf(ConfigAwareContextValuesContainer._keyPrefix) !== 0) {
        return _get(_getPrototypeOf(ConfigAwareContextValuesContainer.prototype), "getValue", this).call(this, key);
      }

      if (this._values.has(key)) {
        return this._values.get(key);
      }

      var configKey = key.substr(ConfigAwareContextValuesContainer._keyPrefix.length);

      var configValue = this._configurationService.getValue(configKey);

      var value = undefined;

      switch (typeof configValue) {
        case 'number':
        case 'boolean':
        case 'string':
          value = configValue;
          break;

        default:
          if (Array.isArray(configValue)) {
            value = JSON.stringify(configValue);
          }

      }

      this._values.set(key, value);

      return value;
    }
  }, {
    key: "setValue",
    value: function setValue(key, value) {
      return _get(_getPrototypeOf(ConfigAwareContextValuesContainer.prototype), "setValue", this).call(this, key, value);
    }
  }, {
    key: "removeValue",
    value: function removeValue(key) {
      return _get(_getPrototypeOf(ConfigAwareContextValuesContainer.prototype), "removeValue", this).call(this, key);
    }
  }]);

  return ConfigAwareContextValuesContainer;
}(Context);

ConfigAwareContextValuesContainer._keyPrefix = 'config.';

var ContextKey = /*#__PURE__*/function () {
  function ContextKey(service, key, defaultValue) {
    _classCallCheck(this, ContextKey);

    this._service = service;
    this._key = key;
    this._defaultValue = defaultValue;
    this.reset();
  }

  _createClass(ContextKey, [{
    key: "set",
    value: function set(value) {
      this._service.setContext(this._key, value);
    }
  }, {
    key: "reset",
    value: function reset() {
      if (typeof this._defaultValue === 'undefined') {
        this._service.removeContext(this._key);
      } else {
        this._service.setContext(this._key, this._defaultValue);
      }
    }
  }, {
    key: "get",
    value: function get() {
      return this._service.getContextKeyValue(this._key);
    }
  }]);

  return ContextKey;
}();

var SimpleContextKeyChangeEvent = /*#__PURE__*/function () {
  function SimpleContextKeyChangeEvent(key) {
    _classCallCheck(this, SimpleContextKeyChangeEvent);

    this.key = key;
  }

  _createClass(SimpleContextKeyChangeEvent, [{
    key: "affectsSome",
    value: function affectsSome(keys) {
      return keys.has(this.key);
    }
  }]);

  return SimpleContextKeyChangeEvent;
}();

var ArrayContextKeyChangeEvent = /*#__PURE__*/function () {
  function ArrayContextKeyChangeEvent(keys) {
    _classCallCheck(this, ArrayContextKeyChangeEvent);

    this.keys = keys;
  }

  _createClass(ArrayContextKeyChangeEvent, [{
    key: "affectsSome",
    value: function affectsSome(keys) {
      var _iterator2 = _createForOfIteratorHelper(this.keys),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var key = _step2.value;

          if (keys.has(key)) {
            return true;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return false;
    }
  }]);

  return ArrayContextKeyChangeEvent;
}();

var CompositeContextKeyChangeEvent = /*#__PURE__*/function () {
  function CompositeContextKeyChangeEvent(events) {
    _classCallCheck(this, CompositeContextKeyChangeEvent);

    this.events = events;
  }

  _createClass(CompositeContextKeyChangeEvent, [{
    key: "affectsSome",
    value: function affectsSome(keys) {
      var _iterator3 = _createForOfIteratorHelper(this.events),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var e = _step3.value;

          if (e.affectsSome(keys)) {
            return true;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return false;
    }
  }]);

  return CompositeContextKeyChangeEvent;
}();

export var AbstractContextKeyService = /*#__PURE__*/function () {
  function AbstractContextKeyService(myContextId) {
    _classCallCheck(this, AbstractContextKeyService);

    this._onDidChangeContext = new PauseableEmitter({
      merge: function merge(input) {
        return new CompositeContextKeyChangeEvent(input);
      }
    });
    this._isDisposed = false;
    this._myContextId = myContextId;
  }

  _createClass(AbstractContextKeyService, [{
    key: "createKey",
    value: function createKey(key, defaultValue) {
      if (this._isDisposed) {
        throw new Error("AbstractContextKeyService has been disposed");
      }

      return new ContextKey(this, key, defaultValue);
    }
  }, {
    key: "onDidChangeContext",
    get: function get() {
      return this._onDidChangeContext.event;
    }
  }, {
    key: "bufferChangeEvents",
    value: function bufferChangeEvents(callback) {
      this._onDidChangeContext.pause();

      try {
        callback();
      } finally {
        this._onDidChangeContext.resume();
      }
    }
  }, {
    key: "createScoped",
    value: function createScoped(domNode) {
      if (this._isDisposed) {
        throw new Error("AbstractContextKeyService has been disposed");
      }

      return new ScopedContextKeyService(this, domNode);
    }
  }, {
    key: "contextMatchesRules",
    value: function contextMatchesRules(rules) {
      if (this._isDisposed) {
        throw new Error("AbstractContextKeyService has been disposed");
      }

      var context = this.getContextValuesContainer(this._myContextId);
      var result = KeybindingResolver.contextMatchesRules(context, rules); // console.group(rules.serialize() + ' -> ' + result);
      // rules.keys().forEach(key => { console.log(key, ctx[key]); });
      // console.groupEnd();

      return result;
    }
  }, {
    key: "getContextKeyValue",
    value: function getContextKeyValue(key) {
      if (this._isDisposed) {
        return undefined;
      }

      return this.getContextValuesContainer(this._myContextId).getValue(key);
    }
  }, {
    key: "setContext",
    value: function setContext(key, value) {
      if (this._isDisposed) {
        return;
      }

      var myContext = this.getContextValuesContainer(this._myContextId);

      if (!myContext) {
        return;
      }

      if (myContext.setValue(key, value)) {
        this._onDidChangeContext.fire(new SimpleContextKeyChangeEvent(key));
      }
    }
  }, {
    key: "removeContext",
    value: function removeContext(key) {
      if (this._isDisposed) {
        return;
      }

      if (this.getContextValuesContainer(this._myContextId).removeValue(key)) {
        this._onDidChangeContext.fire(new SimpleContextKeyChangeEvent(key));
      }
    }
  }, {
    key: "getContext",
    value: function getContext(target) {
      if (this._isDisposed) {
        return NullContext.INSTANCE;
      }

      return this.getContextValuesContainer(findContextAttr(target));
    }
  }]);

  return AbstractContextKeyService;
}();

var ContextKeyService = /*#__PURE__*/function (_AbstractContextKeySe) {
  _inherits(ContextKeyService, _AbstractContextKeySe);

  var _super3 = _createSuper(ContextKeyService);

  function ContextKeyService(configurationService) {
    var _this2;

    _classCallCheck(this, ContextKeyService);

    _this2 = _super3.call(this, 0);
    _this2._contexts = new Map();
    _this2._toDispose = new DisposableStore();
    _this2._lastContextId = 0;
    var myContext = new ConfigAwareContextValuesContainer(_this2._myContextId, configurationService, _this2._onDidChangeContext);

    _this2._contexts.set(_this2._myContextId, myContext);

    _this2._toDispose.add(myContext); // Uncomment this to see the contexts continuously logged
    // let lastLoggedValue: string | null = null;
    // setInterval(() => {
    // 	let values = Object.keys(this._contexts).map((key) => this._contexts[key]);
    // 	let logValue = values.map(v => JSON.stringify(v._value, null, '\t')).join('\n');
    // 	if (lastLoggedValue !== logValue) {
    // 		lastLoggedValue = logValue;
    // 		console.log(lastLoggedValue);
    // 	}
    // }, 2000);


    return _this2;
  }

  _createClass(ContextKeyService, [{
    key: "dispose",
    value: function dispose() {
      this._isDisposed = true;

      this._toDispose.dispose();
    }
  }, {
    key: "getContextValuesContainer",
    value: function getContextValuesContainer(contextId) {
      if (this._isDisposed) {
        return NullContext.INSTANCE;
      }

      return this._contexts.get(contextId) || NullContext.INSTANCE;
    }
  }, {
    key: "createChildContext",
    value: function createChildContext() {
      var parentContextId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._myContextId;

      if (this._isDisposed) {
        throw new Error("ContextKeyService has been disposed");
      }

      var id = ++this._lastContextId;

      this._contexts.set(id, new Context(id, this.getContextValuesContainer(parentContextId)));

      return id;
    }
  }, {
    key: "disposeContext",
    value: function disposeContext(contextId) {
      if (!this._isDisposed) {
        this._contexts.delete(contextId);
      }
    }
  }]);

  return ContextKeyService;
}(AbstractContextKeyService);

ContextKeyService = __decorate([__param(0, IConfigurationService)], ContextKeyService);
export { ContextKeyService };

var ScopedContextKeyService = /*#__PURE__*/function (_AbstractContextKeySe2) {
  _inherits(ScopedContextKeyService, _AbstractContextKeySe2);

  var _super4 = _createSuper(ScopedContextKeyService);

  function ScopedContextKeyService(parent, domNode) {
    var _this3;

    _classCallCheck(this, ScopedContextKeyService);

    _this3 = _super4.call(this, parent.createChildContext());
    _this3._parent = parent;

    if (domNode) {
      _this3._domNode = domNode;

      _this3._domNode.setAttribute(KEYBINDING_CONTEXT_ATTR, String(_this3._myContextId));
    }

    return _this3;
  }

  _createClass(ScopedContextKeyService, [{
    key: "dispose",
    value: function dispose() {
      this._isDisposed = true;

      this._parent.disposeContext(this._myContextId);

      if (this._domNode) {
        this._domNode.removeAttribute(KEYBINDING_CONTEXT_ATTR);

        this._domNode = undefined;
      }
    }
  }, {
    key: "onDidChangeContext",
    get: function get() {
      return Event.any(this._parent.onDidChangeContext, this._onDidChangeContext.event);
    }
  }, {
    key: "getContextValuesContainer",
    value: function getContextValuesContainer(contextId) {
      if (this._isDisposed) {
        return NullContext.INSTANCE;
      }

      return this._parent.getContextValuesContainer(contextId);
    }
  }, {
    key: "createChildContext",
    value: function createChildContext() {
      var parentContextId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._myContextId;

      if (this._isDisposed) {
        throw new Error("ScopedContextKeyService has been disposed");
      }

      return this._parent.createChildContext(parentContextId);
    }
  }, {
    key: "disposeContext",
    value: function disposeContext(contextId) {
      if (this._isDisposed) {
        return;
      }

      this._parent.disposeContext(contextId);
    }
  }]);

  return ScopedContextKeyService;
}(AbstractContextKeyService);

function findContextAttr(domNode) {
  while (domNode) {
    if (domNode.hasAttribute(KEYBINDING_CONTEXT_ATTR)) {
      var attr = domNode.getAttribute(KEYBINDING_CONTEXT_ATTR);

      if (attr) {
        return parseInt(attr, 10);
      }

      return NaN;
    }

    domNode = domNode.parentElement;
  }

  return 0;
}

CommandsRegistry.registerCommand(SET_CONTEXT_COMMAND_ID, function (accessor, contextKey, contextValue) {
  accessor.get(IContextKeyService).createKey(String(contextKey), contextValue);
});